import * as actionType from './type'

const INITIAL_STATE = {
    isLoading : false,
    ownerlist: [],
    currentuser: null,
    rolebasedData: null,
    organizationLabel: null,
    userList : [],
    Team: []
}


export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.RECEIVED_USER: {
            return {
                ...state,
                ownerlist: action.payload
            }
        }

        case actionType.RECEIVED_CURRENT_USER: {
            return {
                ...state,
                currentuser: action.payload?.logeddata,
                rolebasedData: action.payload?.rolebasedData,
                organizationLabel: action?.payload?.organizationLabel
            }
        }

        case actionType.UPDATE_CURRENT_USER_PERMISSION: {
            return {
                ...state,
                rolebasedData: null
            }
        }
        case actionType.REQUEST_GET_USER: {
            return {
                ...state,
                isLoading: true
            }
        }
        case actionType.RECEIVED_SEARCHED_USER: {
            return {
                ...state,
                userList : action?.payload,
                isLoading : false
            }
        }
        case actionType.CLER_TEAM_EMPTY: {
            return {
                ...state,
                Team: []
            }
        }
        default: 
            return {
                ...state
            }
    }
}